export const routePaths = {
  dashboard: '/dashboard',
  pmDashboard: '/dashboard/pm',
  dispatchBoard: '/tasks',
  wbs: '/wbs',
  reports: '/reports',
  field: '/field',
  dfr: '/dfr',
  timesheets: '/timesheets',
  inspections: '/inspections',
  hse: '/hse',
  hseIncidents: '/hse/incidents',
  hseAccidents: '/hse/accidents',
  hseJsas: '/hse/jsas',
  hseHazards: '/hse/hazards',
  hsePpeChecks: '/hse/ppe-checks',
  hseSafetyInspections: '/hse/safety-inspections',
  hseEmergencyContacts: '/hse/emergency-contacts',
  hseFirstAidReadiness: '/hse/first-aid-readiness',
  hseStandDowns: '/hse/stand-downs',
  qs: '/qs',
  contractAdmin: '/contract-admin',
  contractAdminContracts: '/contract-admin/contracts',
  contractAdminSubcontracts: '/contract-admin/subcontracts',
  contractAdminInstructions: '/contract-admin/instructions',
  contractAdminRfis: '/contract-admin/rfis',
  contractAdminVariations: '/contract-admin/variations',
  contractAdminEot: '/contract-admin/extensions-of-time',
  contractAdminClaims: '/contract-admin/claims',
  contractAdminContraCharges: '/contract-admin/contra-charges',
  contractAdminNotices: '/contract-admin/notices',
  contractAdminPaymentApplications: '/contract-admin/payment-applications',
  contractAdminRetention: '/contract-admin/retention',
  contractAdminFinalAccounts: '/contract-admin/final-accounts',
  procurement: '/procurement',
  stores: '/stores',
  equipment: '/equipment',
  accounts: '/accounts',
  financials: '/financials',
  drawdowns: '/drawdowns',
  budget: '/budget',
  changeRequests: '/change-requests',
  permits: '/permits',
  qcTemplates: '/qc-templates',
  defects: '/defects',
  defectAnalytics: '/defects/analytics',
  risks: '/risks',
  unitStatus: '/unit-status',
  resources: '/resources',
  admin: '/admin',
  teamsOverview: '/teams-overview',
  workCalendars: '/admin/calendars',
  documents: '/documents',
  notifications: '/notifications',
  changePassword: '/change-password',
  fieldChangePassword: '/field/change-password',
  syncConflicts: '/sync/conflicts',
} as const;
